// self-registration is appiq-only; other builds share VITE_APP_TYPE='LEAD', so it needs its own flag
export const allowSelfRegistration = import.meta.env.VITE_ALLOW_REGISTRATION === 'true';

/**
 * Locale and currency
 */
export const defaultLocale = 'de-CH';
export const defaultCurrency = 'CHF';

/**
 * Campaign running time
 */
export const defaultMinimumCampaignDuration = 20; // in days
export const defaultCampaignDuration = 30; // in days

/**
 * Budgeting
 */
export const defaultDailyBudget = 50 * 100; // 50 CHF
export const defaultMinimumDailyBudget = 40 * 100; // 40 CHF
